import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Paper,
  Grid,
  TextField,
  Button,
  Chip,
  IconButton,
  Card,
  CardContent,
  CardActions,
  Avatar,
  useTheme,
  InputAdornment,
} from "@mui/material";
import {
  Search as SearchIcon,
  Edit as EditIcon,
  Delete as DeleteIcon,
  Add as AddIcon,
  Category as CategoryIcon,
} from "@mui/icons-material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import Tooltip from "@mui/material/Tooltip";
import useAxios from "../useAxios";
import InfoIcon from "@mui/icons-material/Info"; // Alternative for view details
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye"; // Another view option
import PageviewIcon from "@mui/icons-material/Pageview"; // Magnifying glass
import {
  ArrowBack,
  CheckCircle,
  PlayCircle,
  LocationOn,
  CurrencyRupee,
} from "@mui/icons-material";
import ModernLoder, {
  CategoryDetailsLoader,
  RegistrationIdeasLoader,
  ProductDetailLoader,
  ProductCategoriesLoader,
  ProductDetailSkeleton
} from "./ModernLoder";
import ProductDetailView from "./ProductDetailView";
import EditDeleteModal from "./Modals/EditDeleteModal";
import ConfirmationDialog from "./Modals/ConfirmationDialog";
const ProductCategories = ({ onBack }) => {
  const theme = useTheme();
  const axiosData = useAxios();
  const [ideas, setIdeas] = useState([]);
  const [selectedIdea, setSelectedIdea] = useState(null);
  const [colors, setColors] = useState([
    "#4e79a7",
    "#f28e2b",
    "#e15759",
    "#76b7b2",
    "#59a14f",
    "#edc948",
    "#b07aa1",
    "#ff9da7",
    "#9c755f", // Warm taupe
    "#bab0ab", // Muted gray
    "#4b6c9c", // Desaturated blue
    "#c44e52", // Crimson red
    "#8dd3c7", // Soft teal
    "#fddaec", // Pale pink
    "#b3de69", // Lime green
  ]);
  const [categories, setCategories] = useState([]);
  const [newCategory, setNewCategory] = useState("");
  const [newIdea, setNewIdea] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedCategoryIni, setSelectedCategoryIni] = useState(null);
  console.log("selectedCategory",selectedCategory)
  
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
   console.log("selectedProduct",selectedProduct)
  const [modalOpen, setModalOpen] = useState(false);
  const [modalOpenAdd, setModalOpenAdd] = useState(false);
  const [modalMode, setModalMode] = useState("category"); // 'category' or 'product'
  const [currentItem, setCurrentItem] = useState(null);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [itemToDelete, setItemToDelete] = useState(null);
  const [deleteMode, setDeleteMode] = useState("category");
  const [searchTerm, setSearchTerm] = useState("");
  const [searchTermProduct, setSearchTermProduct] = useState("");
  const [filteredProdctCat, setFilteredProdctCat] = useState([]);
  const [filteredProdct, setFilteredProdct] = useState([]);
  const [dialogConfig, setDialogConfig] = useState({
    open: false,
    title: "",
    message: "",
    type: "delete",
  });
  // Handler for search input change
  const handleSearch = () => {
    const searchValue = searchTerm.toLowerCase();
    const filtered = categories.filter((cate) =>
      cate.name.toLowerCase().includes(searchValue)
    );
    setFilteredProdctCat(filtered);
  };
    const handleSearchAll = async (category) => {
    setLoading(true);
    setSelectedIdea(null);
    setSelectedProduct(null);
    if (category.name === "Registration Ideas") {
      try {
        const res = await axiosData.get(`getIdeasByCategory/${category._id}`);
        setIdeas(res.data.ideas);
        setLoading(false);
      } catch (err) {
        console.error("Failed to fetch ideas", err);
        setLoading(false);
      }
    } else {
      try {
        const res = await axiosData.get(`getAllProductDel`);
        setProducts(res.data.productDetails);
        setSelectedCategory(category);
        setSelectedCategoryIni(category)
        //setFilteredProdct(res.data.productDetails);
        const filteredpro = res.data.productDetails.filter((prod) =>
          prod.produt_name.toLowerCase().includes(searchTerm)
        );
        setFilteredProdct(filteredpro); // ? show only matched products
        setSearchTermProduct(searchTerm);
        setLoading(false);
      } catch (err) {
        console.error("Failed to fetch products", err);
        setLoading(false);
      }
    }
  };
  const handleSearchProduct = () => {
    const searchValue = searchTermProduct.toLowerCase();
    const filtered = products.filter((prod) =>
      prod.produt_name.toLowerCase().includes(searchValue)
    );
    setFilteredProdct(filtered);
  };
  const handleProductClick = async (product) => {
    setLoading(true);
    setSelectedCategory(null);
    setSelectedProduct(product);
    try {
      const res = await axiosData.get(`getProductDetails/${product._id}`);
      //setProducts(res.data.productDetails);
      setLoading(false);
    } catch (err) {
      console.error("Failed to fetch products", err);
      setLoading(false);
    }
  };
  //Get Products Using product ID from data base
  const handleCategoryClick = async (category) => {
    setLoading(true);
    setSelectedCategory(category);
    setSelectedCategoryIni(category)
    setSelectedIdea(null);
    setSelectedProduct(null);
    if (category.name === "Registration Ideas") {
      try {
        const res = await axiosData.get(`getIdeasByCategory/${category._id}`);
        setIdeas(res.data.ideas); // each idea has its own productList
        setLoading(false);
      } catch (err) {
        console.error("Failed to fetch ideas", err);
        setLoading(false);
      }
    } else {
      try {
        const res = await axiosData.get(`getProductDetails/${category?._id}`);
        setProducts(res.data.productDetails);
        setFilteredProdct(res.data.productDetails);
        setLoading(false);
      } catch (err) {
        console.error("Failed to fetch products", err);
        setLoading(false);
      }
    }
  };
useEffect(() => {
  const handler = setTimeout(() => {
    setDebouncedSearch(searchTerm);
  }, 500); // <- wait 500ms after typing stops

  return () => clearTimeout(handler);
}, [searchTerm]);
  useEffect(() => {
    setCategories([]);
    setLoading(true);
    fetchCategory();
  }, []);
  useEffect(() => {
    if (debouncedSearch.length >= 3) {
      // Start searching only after 3 letters
      handleSearchAll("all"); // Or your logic here
    } else if (debouncedSearch.length === 0) {
      setFilteredProdctCat(categories); // Reset on clear
    }
  }, [debouncedSearch]);
  /* Get all users list from api*/
  const fetchCategory = async () => {
    await axiosData
      .get(`getAllProductCategory`)
      .then((data) => {
        setCategories(data.data.productCAtegory);
        setFilteredProdctCat(data.data.productCAtegory);
        setLoading(false);
      })
      .catch((error) => {
        console.log("Error", error);
        setLoading(false);
      });
  };
  const fetchIdeas = async (id) => {
    setLoading(true);
    await axiosData
      .get(`getIdeasByCategory/${id}`)
      .then((data) => {
        setIdeas(data.data.ideas);
        setLoading(false);
      })
      .catch((error) => {
        console.log("Error", error);
        setLoading(false);
      });
  };
  //create category in database
  const handleAddCategory = async () => {
    setLoading(true);
    if (newCategory.trim()) {
      // try {
      //   const randomColor = colors[Math.floor(Math.random() * colors.length)];
      //   const response = await axiosData.post("registerProductCat", {
      //     name: newCategory,
      //     productList: [],
      //   });
      //   if (response.data) {
      //     fetchCategory();
      //     // Push the newly created category from DB response
      //     setCategories((prev) => [...prev, response.data.newCategory]);
      //     setFilteredProdctCat((prev) => [...prev, response.data.newCategory]);
      //     setNewCategory("");
      //     setLoading(false);
      //   }
      // } catch (err) {
      //   console.error("Error adding category", err);
      //   setLoading(false);
      // }
    } else {
      setModalMode("category");
      setCurrentItem(newCategory);
      setModalOpenAdd(true);
      setLoading(false);
    }
  };
  const handleAddIdea = async () => {
    setLoading(true);
    if (newIdea.trim()) {
      try {
        const response = await axiosData.post("createIdea", {
          name: newIdea,
          categoryId: selectedCategory._id,
          productList: [],
        });
        if (response.data) {
          fetchIdeas(selectedCategory._id);
          // Push the newly created category from DB response
          // setIdeas((prev) => [...prev, response.data.ideas]);
          setNewIdea("");
          setLoading(false);
        }
      } catch (err) {
        console.error("Error adding category", err);
        setLoading(false);
      }
    }
  };
  const handleDeleteCategory = (_id) => {
    setCategories(categories.filter((category) => category._id !== _id));
    setFilteredProdctCat(categories.filter((category) => category._id !== _id));
  };
  // Add these functions to your component
  const handleEdit = (item, mode) => {
    setModalMode(mode);
    setCurrentItem(item);
    setModalOpen(true);
  };
  const handleSaveCategoryAdd = async (savedItem) => {
    setLoading(true);
    try {
      const response = await axiosData.post("registerProductCat", {
        name: savedItem.name,
        productList: savedItem.productList,
      });
      if (response.data) {
        fetchCategory();
        // Push the newly created category from DB response
        setCategories((prev) => [...prev, response.data.newCategory]);
        setFilteredProdctCat((prev) => [...prev, response.data.newCategory]);
        setNewCategory("");
        setLoading(false);
      }
    } catch (err) {
      console.error("Error adding category", err);
      setLoading(false);
    }
  };
  const handleSave = async (savedItem) => {
    setLoading(true);
    try {
      if (modalMode === "category") {
        const response = await axiosData.put(`editProductCat`, {
          _id: savedItem._id,
          name: savedItem.name,
          productList: savedItem.productList,
        });
        if (response.data) {
          setCategories(
            categories.map((cat) =>
              cat._id === savedItem._id ? response.data.updatedCategory : cat
            )
          );
          setFilteredProdctCat(
            categories.map((cat) =>
              cat._id === savedItem._id ? response.data.updatedCategory : cat
            )
          );
          fetchCategory();
          setLoading(false);
        }
      } else {
        const response = await axiosData.put(`editProductDetails`, {
          ...savedItem,
          _id: savedItem._id,
          image_local_url: savedItem?.image_local_url || "",
          deliverables: savedItem.deliverables,
          materials_list: savedItem.materials_list,
          reqFromClient: savedItem.reqFromClient,
          image: savedItem.image || null,
        });
        if (response.data) {
          setProducts(
            products.map((prod) =>
              prod._id === savedItem._id ? response.data.result : prod
            )
          );
          setFilteredProdct(
            products.map((prod) =>
              prod._id === savedItem._id ? response.data.result : prod
            )
          );
          if (selectedProduct?._id === savedItem._id) {
            setSelectedProduct(response.data.result);
            fetchCategory();
          }
          setLoading(false);
        }
      }
    } catch (err) {
      console.error("Error saving item", err);
    } finally {
      setLoading(false);
    }
  };
  const handleDeleteClick = (item, mode) => {
    setItemToDelete(item);
    //setDeleteDialogOpen(true);
    setDialogConfig({
      open: true,
      title: `Are you sure you want to delete this ${
        mode === "category" ? "Category" : "Product"
      }?`,
      message: `You're about to permanently delete this ${
        mode === "category" ? "category and all its products" : "product"
      }. This action cannot be undone.`,
      type: "delete",
      onConfirm: () => handleDelete(item),
    });
  };
  const handleDelete = async (item) => {
    setLoading(true);
    try {
      if (!item?.productCategoryID) {
        await axiosData.delete(`deleteProductCat/${item._id}`);
        setCategories(categories.filter((cat) => cat._id !== item._id));
        setFilteredProdctCat(categories.filter((cat) => cat._id !== item._id));
        fetchCategory();
      } else {
       const responseDel = await axiosData.delete(`deleteProductDel/${item._id}`);
         if(responseDel){
        setProducts(products.filter((prod) => prod._id !== item._id));
        setFilteredProdct(products.filter((prod) => prod._id !== item._id));
          // Update the category's productList to remove the deleted product
          const data = products
            .filter(
              (prod) =>
                prod._id !== item._id && prod.productCategoryID === item.productCategoryID
            )
            .map((prod) => prod.produt_name); // or ._id based on what you store in productList
          await axiosData.put(`editProductCat`, {
            _id: item.productCategoryID,
            name: item.productCategory,
            productList: products
            .filter(
              (prod) =>
                prod._id !== item._id && prod.productCategoryID === item.productCategoryID
            )
            .map((prod) => prod.produt_name), // or ._id based on what you store in productList
          });
          fetchCategory()
          if (selectedProduct?._id === item._id) {
          setSelectedProduct(null);
        }
        }
      }
    } catch (err) {
      console.error("Error deleting item", err);
    } finally {
      setLoading(false);
      setDialogConfig({
      open: false,
    });
    }
  };
  if (loading) {
    if (selectedProduct) {
      return (
        <Box
          sx={{
            minHeight: "100vh",
            width:"100%",
            p: { xs: 2, md: 4 },
            bgcolor: "background.default",
            borderRadius: "20px",
          }}
        >
          <ProductDetailSkeleton onBack={onBack}/>
        </Box>
      );
    } 
    else if (selectedCategory) {
      if (selectedCategory.name === "Registration Ideas" && !selectedIdea) {
        return <RegistrationIdeasLoader />;
      } else {
        return (
          <Box
            sx={{
              minHeight: "100vh",
              p: { xs: 2, md: 4 },
              bgcolor: "background.default",
              borderRadius: "20px",
            }}
          >
            <CategoryDetailsLoader />
          </Box>
        );
      }
    } else {
      return (
        <Box
          sx={{
            minHeight: "100vh",
            p: { xs: 2, md: 4 },
            bgcolor: "background.default",
            borderRadius: "20px",
          }}
        >
          {" "}
          <ProductCategoriesLoader />
        </Box>
      ); // or <ModernLoader />
    }
  }
  // if (loading) return (<ModernLoader size={80} primaryColor="#ab0606ff" text="Processing" />);
  return (
    <>
      {/* {selectedCategory?.name === "Registration Ideas" && !selectedIdea && (
        <Grid container spacing={3} sx={{ justifyContent: "center" }}>
          {ideas.length > 0 ? (
            ideas.map((idea) => (
              <Grid item xs={12} sm={6} md={4} key={idea._id}>
                <Card
                  onClick={() => {
                    setSelectedIdea(idea);
                    setProducts(idea.productList || []);
                  }}
                  sx={{
                    height: 180,
                    cursor: "pointer",
                    borderRadius: 3,
                    p: 2,
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    textAlign: "center",
                    boxShadow: "0 6px 16px rgba(0,0,0,0.1)",
                    "&:hover": {
                      boxShadow: "0 10px 20px rgba(0,0,0,0.2)",
                      transform: "translateY(-4px)",
                    },
                  }}
                >
                  <Typography variant="h6" sx={{ fontWeight: 600 }}>
                    {idea.name}
                  </Typography>
                  <Typography variant="body2" sx={{ mt: 1 }}>
                    {idea.description}
                  </Typography>
                </Card>
              </Grid>
            ))
          ) : (
            <Typography>No ideas available</Typography>
          )}
        </Grid>
      )}
      {(selectedCategory?.name !== "Registration Ideas" || selectedIdea) && (
        <Grid container spacing={4} sx={{ justifyContent: "center" }}>
          {products.length > 0 &&(
            products.map((product) => (
              <Grid item xs={12} sm={6} md={4} key={product._id}>
                
              </Grid>
            ))
          ) }
        </Grid>
      )} */}
      {selectedProduct ? (
        <ProductDetailView
          product={selectedProduct}
          onBack={() => {
            setSelectedProduct(null)
            setSelectedCategory(selectedCategoryIni)
          }}
        />
      ) : selectedCategory ? (
        <Box sx={{ px: { xs: 2, sm: 4 } }}>
          <Box
            display="flex"
            flexDirection={{ xs: "column", sm: "row" }}
            justifyContent="space-between"
            alignItems={{ xs: "flex-start", sm: "center" }}
            mb={3}
            gap={{ xs: 2, sm: 0 }}
          >
            {/* Back Button */}
            <Button
              startIcon={<ArrowBack />}
              // onClick={() => {
              //    setSearchTerm("");
              //    setSearchTermProduct("")
              //   if (selectedProduct) {
              //     setSelectedProduct(null);
              //   } else if (selectedIdea) {
              //     setSelectedIdea(null);
              //   } else {
              //     setSelectedCategory(null);
              //   }
              // }}
             onClick={() => {
  setSearchTerm("");
  setSearchTermProduct("");

  // ?? Reset ONLY when no product is selected
  if (!selectedProduct) {
    setSelectedCategory(null);
  }

  setSelectedProduct(null); // always clear product
  setFilteredProdct([]);
}}

              sx={{
                color: "text.primary",
                mb: 2,
                borderRadius: "12px",
                boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                border: "1.5px solid", // Thicker border
                transition: "all 0.3s ease",
                borderColor: "#d32f2f", // Red border color
                "&:hover": {
                  backgroundColor: "action.hover",
                  transform: "translateX(-4px)",
                  boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                  borderColor: "#d32f2f", // Keep red on hover
                  "& .MuiSvgIcon-root": {
                    transform: "translateX(-2px)",
                  },
                },
                "&:active": {
                  transform: "translateX(-2px) scale(0.98)",
                },
              }}
            >
              Back
            </Button>
            <Box display="flex" alignItems="center">
              <TextField
                size="small"
                placeholder="Search products..."
                value={searchTermProduct}
                onChange={(e) => {
                  setSearchTermProduct(e.target.value);
                  const searchValue = e.target.value.toLowerCase();
                  if (searchValue.length >= 3) {
                    const filtered = products.filter((prod) =>
                      prod.produt_name.toLowerCase().includes(searchValue)
                    );
                    setFilteredProdct(filtered);
                  } else {
                    setFilteredProdct(products);
                  }
                }}
                onKeyPress={(e) => e.key === "Enter" && handleSearchProduct()}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon color="action" />
                    </InputAdornment>
                  ),
                }}
                sx={{ mr: 2 }}
              />
              <Button
                variant="contained"
                color="primary"
                onClick={handleSearchProduct}
              >
                Search
              </Button>
            </Box>
          </Box>
          {/* Heading */}
          <Typography
            variant="h4"
            gutterBottom
            sx={{
              fontWeight: 600,
              color: "text.primary",
              textAlign: "center",
              "&:after": {
                content: '""',
                display: "block",
                width: "80px",
                height: "4px",
                background: theme.palette.primary.main,
                margin: "16px auto 0",
                borderRadius: "2px",
              },
            }}
          >
            {selectedIdea
              ? `Products in "${selectedIdea.name}"`
              : selectedCategory.name === "Registration Ideas"
              ? "Select an Idea"
              : "Products in this Category"}
          </Typography>

          {/* If category is "Registration Ideas" and no idea selected */}
          {selectedCategory.name === "Registration Ideas" && !selectedIdea ? (
            <Box>
              <Box display="flex" alignItems="center">
                <TextField
                  fullWidth
                  size="medium"
                  label="New Idea Name"
                  value={newIdea}
                  onChange={(e) => setNewIdea(e.target.value)}
                  sx={{
                    mr: 2,
                    "& .MuiOutlinedInput-root": {
                      borderRadius: 2,
                      background: theme.palette.background.paper,
                    },
                  }}
                />
                <Button
                  variant="contained"
                  color="primary"
                  startIcon={<AddIcon />}
                  onClick={handleAddIdea}
                  sx={{
                    height: "48px",
                    borderRadius: 2,
                    px: 3,
                    fontWeight: 600,
                    boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                    "&:hover": {
                      boxShadow: "0 6px 16px rgba(0,0,0,0.2)",
                    },
                  }}
                >
                  Add Idea
                </Button>
              </Box>
              <Grid container spacing={3} sx={{ justifyContent: "center" }}>
                {ideas.map((idea) => (
                  <Grid item xs={12} sm={6} md={4} key={idea._id}>
                    <Card
                      onClick={() => {
                        setSelectedIdea(idea);
                        setProducts(idea.productList || []);
                        setFilteredProdct(idea.productList || []);
                      }}
                      sx={{
                        height: 180,
                        cursor: "pointer",
                        borderRadius: 3,
                        p: 2,
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                        textAlign: "center",
                        boxShadow: "0 6px 16px rgba(0,0,0,0.1)",
                        "&:hover": {
                          boxShadow: "0 10px 20px rgba(0,0,0,0.2)",
                          transform: "translateY(-4px)",
                        },
                      }}
                    >
                      <Typography variant="h6" sx={{ fontWeight: 600 }}>
                        {idea.name}
                      </Typography>
                      <Typography variant="body2" sx={{ mt: 1 }}>
                        {idea.description}
                      </Typography>
                    </Card>
                  </Grid>
                ))}
              </Grid>
            </Box>
          ) : (
            // Show products for either selected idea or normal category
            <Grid
              container
              spacing={4}
              sx={{ alignItems: "center", justifyContent: "center" }}
            >
              {filteredProdct.length > 0 ? (
                filteredProdct.map((product) => (
                  <Grid item xs={12} sm={6} md={4} key={product._id}>
                    <Card
                    key={product._id}
                      sx={{
                        width: 260,
                        height: { xs: 300, sm: 300, md: 260 },
                        borderRadius: 3,
                        overflow: { xs: "auto", sm: "auto", md: "hidden" },
                        boxShadow: "0 8px 24px rgba(0,0,0,0.08)",
                        transition: "transform 0.3s, box-shadow 0.3s",
                        display: "flex",
                        textAlign: "center",
                        justifyContent: "center",
                        flexDirection: "column",
                        position: "relative", // Add this
                        "&:hover": {
                          transform: "translateY(-5px)",
                          boxShadow: "0 12px 28px rgba(0,0,0,0.12)",
                        },
                      }}
                    >
                      <Box
                        sx={{
                          height: 180,
                          background: `linear-gradient(to bottom, rgba(0,0,0,0.05), rgba(0,0,0,0.1)),
                      url(${
                        product?.image_local_url ||
                        product?.image_local_url != undefined
                          ? `https://api-productcatelog.bilimbe.in/assets/${encodeURIComponent(
                              product.image_local_url
                            )}`
                          : require("../assets/default-no-image.jpg")
                      })`,
                          backgroundSize: "cover",
                          backgroundPosition: "center",
                        }}
                      />
                      <CardContent sx={{ flex: 1, p: 2 }}>
                        <Typography
                          variant="h6"
                          sx={{
                            fontWeight: 600,
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                          }}
                        >
                          {product?.produt_name}
                        </Typography>
                      </CardContent>
                      {/* <CardActions sx={{ p: 2, pt: 0 }}>
                        <Button
                          fullWidth
                          variant="contained"
                          size="medium"
                          onClick={() => setSelectedProduct(product)}
                          sx={{
                            fontWeight: 600,
                            borderRadius: 2,
                            textTransform: "none",
                          }}
                        >
                          View Details
                        </Button>
                      </CardActions> */}
                      {/* Add this overlay for edit/delete buttons */}
                      <Box
                        sx={{
                          position: { xs: "", sm: "", md: "absolute" },
                          top: { xs: 20, sm: 20, md: 0 },
                          left: { xs: 50, sm: 50, md: 0 },
                          right: 0,
                          bottom: 0,
                          p: { xs: 0.5, sm: 0.5, md: 0 },
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          backgroundColor: "rgba(105, 14, 14, 0.5)",
                          opacity: { xs: 1, sm: 1, md: 0 },
                          transition: "opacity 0.3s",
                          //borderRadius: "12px",
                          "&:hover": {
                            opacity: { xs: 0, sm: 1, md: 1 },
                          },
                        }}
                        //                         sx={{
                        //   position: 'absolute',
                        //   bottom: 0,
                        //   left: 0,
                        //   right: 0,
                        //   display: 'flex',
                        //   justifyContent: 'center',
                        //   backgroundColor: 'rgba(0,0,0,0.5)',
                        //   opacity: 0,
                        //   transition: 'opacity 0.3s',
                        //   borderBottomLeftRadius: '12px',
                        //   borderBottomRightRadius: '12px',
                        //   py: 1,
                        //   '&:hover': {
                        //     opacity: 1,
                        //   },
                        // }}
                      >
                        <Box display="flex">
                          <Tooltip title="View Details">
                            <IconButton
                              color="primary"
                              onClick={(e) => {
                                e.stopPropagation();
                                handleProductClick(product);
                              }}
                              sx={{
                                backgroundColor: "white",
                                "&:hover": { backgroundColor: "white" },
                                mx: 1,
                              }}
                            >
                              <VisibilityIcon />
                            </IconButton>
                          </Tooltip>
                          <Tooltip title="Edit">
                            <IconButton
                              color="primary"
                              onClick={(e) => {
                                e.stopPropagation();
                                handleEdit(product, "product");
                              }}
                              sx={{
                                backgroundColor: "white",
                                "&:hover": { backgroundColor: "white" },
                                mx: 1,
                              }}
                            >
                              <EditIcon />
                            </IconButton>
                          </Tooltip>
                          <Tooltip title="Delete">
                            <IconButton
                              color="error"
                              onClick={(e) => {
                                e.stopPropagation();
                                 setDeleteMode("product");
                                handleDeleteClick(product ,"product");
                              }}
                              sx={{
                                backgroundColor: "white",
                                "&:hover": { backgroundColor: "white" },
                                mx: 1,
                              }}
                            >
                              <DeleteIcon />
                            </IconButton>
                          </Tooltip>
                        </Box>
                      </Box>
                    </Card>
                  </Grid>
                ))
              ) : (
                <Typography>No products found.</Typography>
              )}
            </Grid>
          )}
        </Box>
      // ) : selectedCategory ? (
      //   <Box sx={{ px: { xs: 2, sm: 4 } }}>
      //     <Box
      //       display="flex"
      //       gap={20}
      //       //justifyContent="space-between"
      //       alignItems="center"
      //       mb={3}
      //     >
      //       <Button
      //         startIcon={<ArrowBack />}
      //         onClick={() => {
      //           setSearchTerm("");
      //           setSearchTermProduct("")
      //           if (selectedProduct) {
      //             setSelectedProduct(null);
      //           } else if (selectedIdea) {
      //             setSelectedIdea(null);
      //             setProducts([]);
      //             setFilteredProdct([]);
      //           } else {
      //             setSelectedCategory(null);
      //           }
      //         }}
      //         sx={{
      //           //mb: 4,
      //           color: "text.primary",
      //           border: "1.5px solid", // Thicker border
      //           borderColor: "#d32f2f", // Red border color
      //           // backgroundColor:"white",
      //           "&:hover": {
      //             backgroundColor: "action.hover",
      //           },
      //         }}
      //       ></Button>
      //       <Typography
      //         variant="h4"
      //         gutterBottom
      //         sx={{
      //           fontWeight: 600,
      //           color: "text.primary",
      //           mb: 4,
      //           textAlign: "center",
      //           position: "relative",
      //           "&:after": {
      //             content: '""',
      //             display: "block",
      //             width: "80px",
      //             height: "4px",
      //             background: (theme) => theme.palette.primary.main,
      //             margin: "16px auto 0",
      //             borderRadius: "2px",
      //           },
      //         }}
      //       >
      //         Products in this Category
      //       </Typography>
      //     </Box>
      //     <Grid container spacing={4} sx={{ justifyContent: "center" }}>
      //       {products.length > 0 ? (
      //         products.map((product) => (
      //           <Grid item xs={12} sm={6} md={4} key={product._id}>
      //             <Card
      //               sx={{
      //                 width: 260, // Fixed width
      //                 height: 260, // Fixed height
      //                 borderRadius: 3,
      //                 overflow: "hidden",
      //                 boxShadow: "0 8px 24px rgba(0,0,0,0.08)",
      //                 transition: "transform 0.3s, box-shadow 0.3s",
      //                 display: "flex",
      //                 textAlign: "center",
      //                 justifyContent: "center",
      //                 flexDirection: "column",
      //                 "&:hover": {
      //                   transform: "translateY(-5px)",
      //                   boxShadow: "0 12px 28px rgba(0,0,0,0.12)",
      //                 },
      //               }}
      //             >
      //               <Box
      //                 sx={{
      //                   height: 150,
      //                   position: "relative",
      //                   background: `linear-gradient(to bottom, rgba(0,0,0,0.05), rgba(0,0,0,0.1)),
      //                           url(${
      //                             product.image_local_url
      //                               ? `https://api-productcatelog.bilimbe.in/assets/${encodeURIComponent(
      //                                   product.image_local_url
      //                                 )}`
      //                               : require("../assets/default-no-image.jpg")
      //                           })`,
      //                   backgroundSize: "cover",
      //                   backgroundPosition: "center",
      //                 }}
      //               />
      //               <CardContent
      //                 sx={{
      //                   flex: 1,
      //                   display: "flex",
      //                   flexDirection: "column",
      //                   p: 2,
      //                   overflow: "hidden",
      //                 }}
      //               >
      //                 <Typography
      //                   variant="h6"
      //                   sx={{
      //                     fontWeight: 600,
      //                     whiteSpace: "nowrap",
      //                     overflow: "hidden",
      //                     textOverflow: "ellipsis",
      //                   }}
      //                 >
      //                   {product?.produt_name}
      //                 </Typography>

      //                 {/* <Typography
      //                   variant="body2"
      //                   color="text.secondary"
      //                   sx={{
      //                     flex: 1,
      //                     overflow: "hidden",
      //                     textOverflow: "ellipsis",
      //                     display: "-webkit-box",
      //                     WebkitLineClamp: 3,
      //                     WebkitBoxOrient: "vertical",
      //                     mb: 1,
      //                   }}
      //                 >
      //                   {product.shortDescription}
      //                 </Typography> */}

      //                 {/* {product.price && (
      //         <Typography 
      //           variant="subtitle1" 
      //           sx={{ 
      //             fontWeight: 700, 
      //             color: 'primary.main',
      //             mt: 'auto'
      //           }}
      //         >
      //           ${product.price.toFixed(2)}
      //         </Typography>
      //       )} */}
      //               </CardContent>
      //               <CardActions sx={{ p: 2, pt: 0 }}>
      //                 <Button
      //                   fullWidth
      //                   variant="contained"
      //                   size="medium"
      //                   onClick={() => handleProductClick(product)}
      //                   sx={{
      //                     fontWeight: 600,
      //                     borderRadius: 2,
      //                     textTransform: "none",
      //                   }}
      //                 >
      //                   View Details
      //                 </Button>
      //               </CardActions>
      //             </Card>
      //           </Grid>
      //         ))
      //       ) : (
      //         <Typography
      //           sx={{
      //             fontWeight: 600,
      //             color: "text.primary",
      //             mb: 4,
      //             textAlign: "center",
      //             justifyContent: "center",
      //             position: "relative",
      //           }}
      //         >
      //           No Products found in this Category
      //         </Typography>
      //       )}
      //     </Grid>
      //   </Box>
      // ) : selectedProduct ? (
      //   <ProductDetailView
      //     product={selectedProduct}
      //     onBack={() => {
      //       //setSelectedCategory(selectedCategory)
      //       setSelectedProduct(null);
      //     }}
      //   />
      ) : (
        // <Box mt={4} p={3} border="1px solid #ccc" borderRadius={2}>
        //   <Typography variant="h5">{selectedProduct.produt_name}</Typography>
        //   <Typography variant="subtitle1" gutterBottom>
        //     Price: <CurrencyRupee sx={{fontSize:"15px",textAlign:"center"}}/>{selectedProduct.price}
        //   </Typography>
        //   <Typography>{selectedProduct.shortDescription}</Typography>
        //   <Button onClick={() => setSelectedProduct(null)} sx={{ mt: 2 }}>
        //     Back to Products
        //   </Button>
        // </Box>
        <Box>
          <Box
            display="flex"
            flexDirection={{ xs: "column", sm: "row" }}
            justifyContent="space-between"
            alignItems={{ xs: "flex-start", sm: "center" }}
            mb={3}
            gap={{ xs: 2, sm: 0 }}
          >
            <Typography
              variant="h4"
              gutterBottom
              sx={{
                fontWeight: 600,
                color: theme.palette.text.primary,
                lineHeight: 1.2,
                mb: { xs: 1, sm: 0 },
              }}
            >
              Product Categories
            </Typography>
            <Box display="flex" alignItems="center">
              <TextField
                size="small"
                placeholder="Search categories..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value.toLowerCase())}
                onKeyPress={(e) => e.key === "Enter" && handleSearch()}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon color="action" />
                    </InputAdornment>
                  ),
                }}
                sx={{ mr: 2 }}
              />
              <Button
                variant="contained"
                color="primary"
                onClick={handleSearch}
              >
                Search
              </Button>
            </Box>
            <Box
              display="flex"
              alignItems="center"
              width={{ xs: "100%", sm: "auto" }}
              flexDirection={{ xs: "column", sm: "row" }}
              gap={{ xs: 2, sm: 0 }}
            >
              {/* <TextField
                fullWidth
                size="medium"
                label="New Category Name"
                value={newCategory}
                onChange={(e) => setNewCategory(e.target.value)}
                sx={{
                  mr: { xs: 0, sm: 2 },
                  width: { xs: "100%", sm: "auto" },
                  "& .MuiOutlinedInput-root": {
                    borderRadius: 2,
                    background: theme.palette.background.paper,
                  },
                }}
              /> */}
              <Button
                variant="contained"
                color="primary"
                startIcon={<AddIcon />}
                onClick={handleAddCategory}
                sx={{
                  height: "48px",
                  borderRadius: 2,
                  px: 3,
                  fontWeight: 600,
                  width: { xs: "100%", sm: "auto" },
                  boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                  "&:hover": {
                    boxShadow: "0 6px 16px rgba(0,0,0,0.2)",
                  },
                }}
              >
                Add Category
              </Button>
            </Box>
          </Box>
          <Grid container spacing={3} sx={{ justifyContent: "center" }}>
            {filteredProdctCat.map((category, index) => (
              <Grid
                item
                xs={12}
                sm={6}
                md={4}
                lg={3}
                key={category?._id}
                // onClick={() => handleCategoryClick(category)}
                sx={{
                  cursor: "pointer",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <Card
                key={category?._id}
                  sx={{
                    height: { xs: "190px", sm: "190px", md: "150px" },
                    width: "280px",
                    display: "flex",
                    flexDirection: "column",
                    borderRadius: 3,
                    boxShadow: "0 8px 16px rgba(0,0,0,0.1)",
                    transition: "transform 0.3s, box-shadow 0.3s",
                    position: "relative", // Add this
                    overflow: { xs: "auto", sm: "auto", md: "hidden" },
                    "&:hover": {
                      transform: "translateY(-5px)",
                      boxShadow: "0 12px 24px rgba(0,0,0,0.15)",
                    },
                    borderTop: `4px solid ${colors[index % colors.length]}`,
                  }}
                >
                  <CardContent sx={{ flexGrow: 1 }}>
                    <Box display="flex" alignItems="center" mb={1}>
                      <Avatar
                        sx={{
                          bgcolor: `${colors[index % colors.length]}`,
                          mr: 2,
                          width: 40,
                          height: 40,
                        }}
                      >
                        <CategoryIcon
                          fontSize="small"
                          sx={{ color: "white" }}
                        />
                      </Avatar>
                      <Typography
                        variant="h6"
                        component="div"
                        sx={{ fontWeight: 600 }}
                      >
                        {category?.name}
                      </Typography>
                    </Box>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        mt: 1,
                      }}
                    >
                      <Chip
                        label={`${
                          category?.productList?.length === undefined
                            ? 0
                            : category?.productList?.length
                        } products`}
                        color="primary"
                        variant="outlined"
                        size="medium"
                        sx={{
                          fontSize: "0.9rem",
                          px: 2,
                          py: 1,
                          background:
                            theme.palette.mode === "dark"
                              ? "rgba(255,255,255,0.1)"
                              : "rgba(0,0,0,0.05)",
                        }}
                      />
                    </Box>
                  </CardContent>
                  {/* For category cards (add to the CardContent): */}
                  {/* Add this overlay for edit/delete buttons */}
                  <Box
                    sx={{
                      position: { xs: "", sm: "", md: "absolute" },
                      top: { xs: 20, sm: 20, md: 0 },
                      left: { xs: 50, sm: 50, md: 0 },
                      right: 0,
                      bottom: 0,
                      p: { xs: 0.5, sm: 0.5, md: 0 },
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      backgroundColor: "rgba(105, 14, 14, 0.5)",
                      opacity: { xs: 1, sm: 1, md: 0 },
                      transition: "opacity 0.3s",
                      // borderRadius: "12px",
                      "&:hover": {
                        opacity: { xs: 0, sm: 1, md: 1 },
                      },
                    }}
                  >
                    <Box display="flex">
                      <Tooltip title="View Details">
                        <IconButton
                          color="primary"
                          onClick={(e) => {
                            e.stopPropagation();
                            handleCategoryClick(category);
                          }}
                          sx={{
                            backgroundColor: "white",
                            "&:hover": { backgroundColor: "white" },
                            mx: 1,
                          }}
                        >
                          <VisibilityIcon />
                        </IconButton>
                      </Tooltip>
                      <Tooltip title="Edit">
                        <IconButton
                          color="primary"
                          onClick={(e) => {
                            e.stopPropagation();
                            handleEdit(category, "category");
                          }}
                          sx={{
                            backgroundColor: "white",
                            "&:hover": { backgroundColor: "white" },
                            mx: 1,
                          }}
                        >
                          <EditIcon />
                        </IconButton>
                      </Tooltip>
                      <Tooltip title="Delete">
                        <IconButton
                          color="error"
                          onClick={(e) => {
                            e.stopPropagation();
                            setDeleteMode("category");
                            handleDeleteClick(category, "category");
                          }}
                          sx={{
                            backgroundColor: "white",
                            "&:hover": { backgroundColor: "white" },
                            mx: 1,
                          }}
                        >
                          <DeleteIcon />
                        </IconButton>
                      </Tooltip>
                    </Box>
                  </Box>
                  {/* <CardActions sx={{ 
                justifyContent: 'flex-end',
                p: 2,
                borderTop: `1px solid ${theme.palette.divider}`
              }}>
                <IconButton 
                  aria-label="edit" 
                  size="small"
                  sx={{
                    '&:hover': {
                      color: theme.palette.primary.main,
                      background: 'rgba(25, 118, 210, 0.08)'
                    }
                  }}
                >
                  <EditIcon fontSize="small" />
                </IconButton>
                <IconButton 
                  aria-label="delete" 
                  size="small" 
                  onClick={() => handleDeleteCategory(category.id)}
                  sx={{
                    '&:hover': {
                      color: theme.palette.error.main,
                      background: 'rgba(211, 47, 47, 0.08)'
                    }
                  }}
                >
                  <DeleteIcon fontSize="small" />
                </IconButton>
              </CardActions> */}
                </Card>
              </Grid>
            ))}
          </Grid>
        </Box>
      )}
      <EditDeleteModal
        open={modalOpen}
        handleClose={() => setModalOpen(false)}
        mode={modalMode}
        data={currentItem}
        onSave={handleSave}
        onDelete={handleDeleteClick}
      />
      <EditDeleteModal
        open={modalOpenAdd}
        handleClose={() => setModalOpenAdd(false)}
        mode={modalMode}
        data={currentItem}
        onSave={handleSaveCategoryAdd}
        onDelete={handleDeleteClick}
      />
      <ConfirmationDialog
        open={dialogConfig.open}
        onClose={() => setDialogConfig((prev) => ({ ...prev, open: false }))}
        onConfirm={dialogConfig.onConfirm}
        title={dialogConfig.title}
        message={dialogConfig.message}
        type={dialogConfig.type}
      />
    </>
  );
};
export default ProductCategories;
